// extracted by mini-css-extract-plugin
module.exports = {"footer_link":"enter_details_manually__footer_link__I-oGT text__text_align_center__2cSPH"};